(() => {
  const controllers = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function init(host) {
    if (controllers.has(host)) return;
    let renderer, loading, near = false, visible = false, disposed = false;
    const sync = async () => {
      const active = visible && !document.hidden && !reduced.matches;
      if (renderer) { renderer.setActive(active); return; }
      if (!near || document.hidden || reduced.matches || loading || disposed) return;
      host.dataset.rendering = 'loading';
      loading = import(host.dataset.shaderSrc);
      try {
        const module = await loading;
        if (!disposed && host.isConnected) renderer = module.mountFooter(host, visible && !document.hidden && !reduced.matches);
      } catch { host.dataset.rendering = 'unavailable'; }
    };
    const prefetch = new IntersectionObserver(entries => { near = entries[0].isIntersecting; sync(); }, {rootMargin:'300px 0px'});
    const visibility = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
    prefetch.observe(host); visibility.observe(host);
    document.addEventListener('visibilitychange', sync);
    reduced.addEventListener('change', sync);
    controllers.set(host, () => {
      disposed = true; prefetch.disconnect(); visibility.disconnect();
      document.removeEventListener('visibilitychange', sync); reduced.removeEventListener('change', sync);
      renderer?.destroy(); controllers.delete(host);
    });
  }
  function scan() {
    for (const [host, dispose] of controllers) if (!host.isConnected) dispose();
    document.querySelectorAll('[data-ld-shader][data-shader-src]').forEach(init);
  }
  scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(scan));
})();
